import api from "../services/BackendServices";
import { parseJwt } from "../utils/parseJwt";
const ecommerceModel = {
  state: {
    cart: {},
    isLoading: false,
    message: "",
    response: null,
    cartVersion: 0,
  },
  reducers: {
    setCart(state, cart) {
      return Object.assign({}, { ...state, cart: cart });
    },
    setMessage(state, msj) {
      return Object.assign({}, { ...state, message: msj });
    },
    resetCart(state) {
      return Object.assign({}, { ...state, cart: {} });
    },
    setLoading(state, isLoading) {
      return Object.assign({}, { ...state, isLoading: isLoading });
    },
    setResponse(state, response) {
      return Object.assign({}, { ...state, response: response });
    },
    clearResponse(state) {
      return Object.assign({}, { ...state, response: null });
    },
    updateCartVersion(state, payload) {
      return Object.assign({}, { ...state, cartVersion: state.cartVersion++ });
    },
  },
  effects: {
    async updateCart(payload, state) {
      if (payload) {
        this.setLoading(true);
        const { client, sucursal } = state.sso;
        const otherModelState = parseJwt(state.sso.token); // ssoModel.state.token(state.ssoModel);
        try {
          const response = await api.EcommerceServices.getCurrentOrder(
            payload,
            client.id.id,
            sucursal.id.clBranchOffice
          );
          this.setCart(response.data);
          this.updateCartVersion();
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
        }
        return true;
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async addToCart({ publicKey, products, ...rest }, state) {
      if (publicKey) {
        this.setLoading(true);
        const { client, sucursal } = state.sso;
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.addToCart(
            publicKey,
            client.id.id,
            sucursal.id.clBranchOffice,
            products,
            {
              observacion: rest?.observation,
              transporte: rest?.transport,
              updateProduct: rest.updateProduct ? true : false,
            }
          );
          if (response.data.validations.length > 0) {
            alert(
              response.data.validations.map((message) => message).join("\n")
            );
          }

          this.setResponse(response);
          this.updateCart(publicKey);
          this.setLoading(false);
        } catch (e) {
          alert(e?.response?.data?.message ? e?.response?.data?.message : e);
          this.setLoading(false);
        }
        return true;
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async removeFromCart({ publicKey, id }, state) {
      if (publicKey) {
        this.setLoading(true);
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.removeFromCart(
            publicKey,
            id
          );
          this.setResponse(response);
          this.updateCart(publicKey);
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
        }
        return true;
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async cleanCart(publicKey, state) {
      if (publicKey) {
        this.setLoading(true);
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.cleanCart(
            publicKey,
            state.ecommerce.cart.order.number
          );
          this.setResponse(response);
          this.updateCart(publicKey);
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
        }
        return true;
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
    async sendCart(data, state) {
      if (data.publicKey) {
        this.setLoading(true);
        const { client, sucursal } = state.sso;
        const { cart } = state.ecommerce;
        this.setMessage("");
        try {
          const response = await api.EcommerceServices.sendCart({
            orderId: cart.order.number,
            clientId: client.id.id,
            ...data,
          });
          alert("El pedido fue enviado");
          this.setResponse(response);
          this.updateCart(data.publicKey);
          this.setLoading(false);
        } catch (e) {
          this.setLoading(false);
        }
      } else {
        alert("Ha ocurrido un problema. Cierre sesión y vuelva a ingresar.");
      }
    },
  },
};
export default ecommerceModel;
